
export default {
  name: 'account-menu',
  props: {
    value: { type: Boolean, default: false }
  },
  computed: {
    opened: function () {
      return this.value;
    }
  },
  methods: {
    toastMock: function () {
      if (window.A && A.toast) A.toast('mock：未接线');
    },
    close: function () {
      this.$emit('input', false);
    },
    onLogout: function () {
      this.$emit('logout');
      this.close();
    }
  }
};
